<template>
  <div>
    <div class="nav-wrap">
      <div class="item" v-for="(item, index) in navs" :key="index">
        <a>
          <div
            v-if="haveActive"
            @click="change(item, index)"
            :class="{ active: activeTab === index }"
          >
            {{ item.label ? item.label : item }}
          </div>
          <div
            v-else
            @click="change(item, index)"
            :class="{ active: currentTab === index }"
          >
            {{ item.label ? item.label : item }}
          </div>
        </a>
      </div>
    </div>
    <transition name="slide">
      <div class="mobileNav" v-show="this.$store.state.shownav">
        <div
          class="item"
          v-for="(item, index) in navs"
          :key="index"
          @click="showMobileNav"
        >
          <a>
            <div
              v-if="haveActive"
              @click="change(item, index)"
              :class="{ active: activeTab === index }"
            >
              {{ item.label ? item.label : item }}
            </div>
            <div
              v-else
              @click="change(item, index)"
              :class="{ active: currentTab === index }"
            >
              {{ item.label ? item.label : item }}
            </div>
          </a>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "navSlider",
  props: {
    navs: {
      type: Array,
    },
    currentTab: {
      default: 0,
    },
    haveActive: {
      default: true,
    },
  },
  data() {
    return {
      activeTab: 0,
      shownav: false,
    };
  },
  watch: {
    currentTab() {
      this.activeTab = this.currentTab;
    },
  },
  created() {
    this.activeTab = this.currentTab;
    if (this.currentTab === -1) {
      this.activeTab = 0;
    }
  },
  methods: {
    change(item, index) {
      this.activeTab = index;
      if (item.value) {
        item.index = index;
        this.$emit("change", item.value, item);
      } else {
        this.$emit("change", item, index);
      }
    },
    showMobileNav() {
      this.$store.state.shownav = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";

@media screen and (min-width: 1201px) {
  .nav-wrap {
    .item {
      /*background-color: #E91D1D;*/
      margin-right: 80px;
      height: 30px;
      line-height: 30px;
      a div:hover {
        color: $color-orange;
      }
      .active {
        color: $color-orange;
        // border-bottom: 3px solid $color-orange;
      }
    }
  }
  .mobileNav {
    display: none;
  }
}

@media screen and (max-width: 1200px) {
  .nav-wrap {
    display: none !important;
  }
  .mobileNav {
    position: absolute;
    top: 50px;
    text-align: center;
    padding: 10px 0;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.8);
    z-index: 8;
    border-top: 1px solid rgba(0, 0, 0, 0.05);
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
    .item {
      margin: 10px 0;
    }
  }
  .slide-enter-active {
    animation: slide-down 0.4s ease-in-out;
  }
  .slide-leave-active {
    animation: slide-down 0.4s reverse ease-in-out;
  }
  @keyframes slide-down {
    from {
      transform: translateY(-100%);
    }
    to {
      transform: translateY(0);
    }
  }
}
</style>